import { Injectable } from '@angular/core';
import { GraphQLClient } from '@biorec/common';
import { Message, MessagesListType, Response , MessageEventDtoInput } from '@biorec/partners/domain';
import { UpdateMessageEventDocument, MessagesListDocument } from '@biorec/partners/gql';
import { Observable, Subject } from 'rxjs';
import { map, share } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class MessagesServiceGql {

	private readonly observables = {
		[MessagesListType.Personal]: new Subject<Message[]>,
		[MessagesListType.Global]: new Subject<Message[]>,
		[MessagesListType.All]: new Subject<Message[]>
	};

	constructor(private client: GraphQLClient) {
	}

	getListObserver(type: MessagesListType): Observable<Message[]> {
		return this.observables[type].asObservable();
	}

	getMessagesList(type: MessagesListType): Observable<Message[]> {
		const o = this.client.request(MessagesListDocument, {type: type})
				.pipe(map(result => result.MessagesList as Message[]), share())
		o.subscribe(data => this.observables[type].next(data));
		return this.observables[type];
	}

	updateMessage(dto: MessageEventDtoInput, type: MessagesListType): Observable<Response> {
		const o = this.client.request(UpdateMessageEventDocument, { dto: dto })
			.pipe(map(result => result.UpdateMessageEvent), share());
		o.subscribe(() => dto.read ? this.getMessagesList(type) : null);
		return o;
	}

}
